// Module
var code = `<div class="card">
	<div class="card-header" ng-click="\$ctrl.isCollapsed = !\$ctrl.isCollapsed"
		style="cursor: pointer;border-bottom: 3px solid {{\$ctrl.scene.color}} !important;">
		<span class="h4 card-title">
			<i class="fas fa-fw"
				ng-class="{'fa-chevron-right': \$ctrl.isCollapsed, 'fa-chevron-down': !\$ctrl.isCollapsed}"></i> Scene Log
		</span>
	</div>
	<div class="card-body" ng-show="!\$ctrl.isCollapsed">
		<div class="row mb-2">
			<div class="col-12">
				<button class="btn btn-sm btn-reset-playlist" ng-click="\$ctrl.resetPlaylistHead()"
					title="Restart playlist from the first item">
					<i class="fas fa-undo"></i> Reset Queue </button>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<table class="table table-sm table-striped player-log-table" style="table-layout: fixed; width: 100%;">
					<tr>
						<th style="width: 1.5rem;"></th>
						<th>Name</th>
						<th style="width: 5rem;">Start</th>
						<th style="width: 5rem;">End</th>
					</tr>
					<tr ng-repeat="item in \$ctrl._\$scope.playListLog"
						ng-style="\$ctrl.scene && \$ctrl.scene.currentlyPlayingId == item.id && {'background-color': \$ctrl.scene.color }"
						ng-class="{ 'highlight': \$ctrl.scene && \$ctrl.scene.currentlyPlayingId == item.id, 'removed': item.removed && item.removed === true && \$ctrl.scene && \$ctrl.scene.currentlyPlayingId != item.id }">
						<td>
							<i ng-if="item.type === 'file'" class="fas fa-file"></i>
							<i ng-if="item.type === 'serviceAnnouncement'" class="fas fa-bullhorn"></i>
							<i ng-if="item.type === 'social'" class="fas fa-users"></i>
						</td>
						<td>
							<div class="truncate">{{item.itemName}}</div>
						</td>
						<td class="text-nowrap">{{item.timePlayed | amDateFormat:'HH:mm:ss'}}</td>
						<td class="text-nowrap">{{item.playbackEnded | amDateFormat:'HH:mm:ss'}}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</div>`;
// Exports
export default code;